var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-sales-records" },
    _vm._l(_vm.list, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "setup-item",
          class: { "last-item": item.last }
        },
        [
          _c("div", { staticClass: "item-left" }, [
            _c("div", { staticClass: "item-time" }, [
              _c("div", { staticClass: "date" }, [
                _vm._v(_vm._s(_vm._f("formateTime")(item.time, "y/m/d")))
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm._f("formateTime")(item.time, "h:m")))
              ])
            ]),
            _vm._m(0, true)
          ]),
          _c("div", { staticClass: "item-right" }, [
            _vm._v(_vm._s(item.context))
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("div", { staticClass: "icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }